module.exports = __webpack_public_path__ + "img/m-bg1.a13220a8.png";